var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05713 16.75V14.0857C2.05713 13.7071 2.36427 13.4071 2.7357 13.4071H6.27856",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2286 11.8571C4.83217 11.8571 5.32146 11.3679 5.32146 10.7643C5.32146 10.1607 4.83217 9.67143 4.2286 9.67143C3.62503 9.67143 3.13574 10.1607 3.13574 10.7643C3.13574 11.3679 3.62503 11.8571 4.2286 11.8571Z",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27859 7.47143C6.88216 7.47143 7.37144 6.98214 7.37144 6.37857C7.37144 5.775 6.88216 5.28571 6.27859 5.28571C5.67502 5.28571 5.18573 5.775 5.18573 6.37857C5.18573 6.98214 5.67502 7.47143 6.27859 7.47143Z",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6857 7.47143C14.2893 7.47143 14.7786 6.98214 14.7786 6.37857C14.7786 5.775 14.2893 5.28571 13.6857 5.28571C13.0821 5.28571 12.5928 5.775 12.5928 6.37857C12.5928 6.98214 13.0821 7.47143 13.6857 7.47143Z",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6786 16.75V13.6643C12.6786 13.1929 12.3 12.8143 11.8286 12.8143H8.07858C7.60715 12.8143 7.22858 13.1929 7.22858 13.6643V16.75",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94998 11.25C10.7074 11.25 11.3214 10.636 11.3214 9.87857C11.3214 9.12115 10.7074 8.50714 9.94998 8.50714C9.19256 8.50714 8.57855 9.12115 8.57855 9.87857C8.57855 10.636 9.19256 11.25 9.94998 11.25Z",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9143 16.75V14.0857C17.9143 13.7071 17.6072 13.4072 17.2357 13.4072H13.6929",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7357 11.8571C16.3393 11.8571 16.8286 11.3679 16.8286 10.7643C16.8286 10.1607 16.3393 9.67143 15.7357 9.67143C15.1322 9.67143 14.6429 10.1607 14.6429 10.7643C14.6429 11.3679 15.1322 11.8571 15.7357 11.8571Z",
    stroke: "#24293D",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.bb026574ada7828bcd6c029e4f040a22.svg";
export { ForwardRef as ReactComponent };